import {Stack, Typography, Divider} from "@mui/material";
import {isEmpty} from "../../config/commonFunctions";
import {keys} from "../../config/nameSpacesKeys";
import {useState} from "react";

export default function LanguageListDisplay(props) {
  const [languageList, setLanguageList] = useState(props.languageList);
  const {defaultLanguage, mappings, topLabel} = props;

  function getLabel(key, defaultValue) {
    const returnValue = mappings[key] || defaultValue;
    if (!returnValue) {
      return key;
    }
    return returnValue;
  }

  if (!languageList || languageList.length === 0) return null;

  return (
    <div>
      {/* Language Heading */}
      <Typography variant="h4" gutterBottom noWrap sx={{pt: 1}}>{topLabel}</Typography>
      {/* Iterate through the language list */}
      {languageList.map((item, index) => {
        const isLastElement = index === languageList.length - 1;
        return (
          <Stack key={index} sx={{pt: 1}} spacing={1}>
            {/* Language Code */}
            {!isEmpty(getLabel(item.languageCode.getValue())) && (
              <div>
                <Typography variant="body2" className={"key"}>
                  {getLabel(keys.languageCode, "languageCode")}
                </Typography>
                <Typography variant="body1">
                  {getLabel(item.languageCode.getValue(defaultLanguage))}
                </Typography>
              </div>
            )}
            {/* Region */}
            {!isEmpty(getLabel(item.region.getValue())) && (
              <div>
                <Typography variant="body2" className={"key"}>
                  {getLabel(keys.region, "region")}
                </Typography>
                <Typography variant="body1">
                  {getLabel(item.region.getValue(defaultLanguage))}
                </Typography>
              </div>
            )}
            {/* Script */}
            {!isEmpty(getLabel(item.script.getValue())) && (
              <div>
                <Typography variant="body2" className={"key"}>
                  {getLabel(keys.script, "script")}
                </Typography>
                <Typography variant="body1">
                  {getLabel(item.script.getValue(defaultLanguage))}
                </Typography>
              </div>
            )}
            {/* Variants */}
            {!isEmpty(item.variant.getList()) && (
              <div>
                <Typography variant="body2" className={"key"}>
                  {getLabel(keys.variant, "variant")}
                </Typography>
                {item.variant.getList().map((variantItem, variantIndex) => (
                  <Typography variant="body1" key={variantIndex}>{getLabel(variantItem.getValue())}</Typography>
                ))}
              </div>
            )}
            {/* Language Variety Name */}
            {!isEmpty(getLabel(item.languageVarietyName.getValue(defaultLanguage))) && (
              <div>
                <Typography variant="body2" className={"key"}>
                  {getLabel(keys.languageVarietyName, "languageVarietyName")}
                </Typography>
                <Typography variant="body1">
                  {getLabel(item.languageVarietyName.getValue(defaultLanguage))}
                </Typography>
              </div>
            )}
            <Divider component="div" role="presentation" className={`dashed ${isLastElement ? "hide-divider" : ""}`} />
          </Stack>
        );
      },
      )}
    </div>
  );
}
